module.exports = __webpack_public_path__ + "static/media/LogoWirebitTransfer-03.aba5f46a.png";